export default __webpack_public_path__ + "static/media/johntravolta.cdf2d43c.gif";